// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"333":"197eeb39","793":"e975a1aa","860":"e975a1aa","4666":"e975a1aa","7174":"197eeb39"}[chunkId] + ".chunk.css";
};